/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { Controller, useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Col } from "../../../components/simple";

const filterObjectArray = (arr = [], filterArr = []) => {
  let result = [];
  result = arr.filter(item => {
    return !!filterArr?.some(f => f.item?.country === item.country);
  });
  return result;
};

const CompanySubscription = ({
  onSubmit,
  errors = {},
  allCountryDatasets = [],
  categories = [],
  subscription,
  resetForm
}) => {
  const { handleSubmit, control, setValue, register } = useForm();

  const [availableCategories, setAvailableCategories] = useState([]);
  const [allowedAddCategories, setAllowedAddCategories] = useState([]);
  const [allowedExcCategories, setAllowedExcCategories] = useState([]);

  const subscriptionTypeRef = useRef();
  const expirationDateRef = useRef();
  const dataSetsRef = useRef();
  const additionalCategoriesRef = useRef();
  const excludedCategoriesRef = useRef();

  const handleCountryDataSetChange = data => {
    if (data && data.length) {
      const filtererCategories = filterObjectArray(categories, data);
      setAvailableCategories(filtererCategories);
    } else {
      setAvailableCategories([]);
    }
  };

  useEffect(() => {
    setAllowedAddCategories(availableCategories.filter(item => item.custom));
    setAllowedExcCategories(availableCategories.filter(item => !item.custom));
  }, [availableCategories]);

  useEffect(() => {
    if (subscription) {
      const {
        subscriptionType,
        countryDatasets,
        excludedCategories,
        expirationDate,
        additionalCategories,
        showAffinityNumbers,
        downloadData
      } = subscription;
      if (subscriptionTypeRef?.current?.select) {
        subscriptionTypeRef.current.select.setValue({
          value: subscriptionType,
          label: subscriptionType
        });
      }
      if (dataSetsRef?.current?.select) {
        const datasets = countryDatasets?.map(item => {
          return {
            value: item.id,
            label: item.name,
            item
          };
        });
        setValue("country_datasets", datasets);
        dataSetsRef.current.select.setValue(datasets);
        handleCountryDataSetChange(datasets);
      }
      if (additionalCategoriesRef?.current?.select) {
        const data = additionalCategories?.map(item => {
          return {
            value: item.id,
            label: item.name,
            item
          };
        });
        setValue("additional_categories", data);
        additionalCategoriesRef.current.select.setValue(data);
      }
      if (excludedCategoriesRef?.current?.select) {
        const data = excludedCategories?.map(item => {
          return {
            value: item.id,
            label: item.name,
            item
          };
        });
        setValue("excluded_categories", data);
        excludedCategoriesRef.current.select.setValue(data);
      }
      if (expirationDateRef?.current && expirationDate) {
        expirationDateRef.current.props.onChange(new Date(expirationDate));
      }
      setValue("show_affinity_numbers", showAffinityNumbers);
      setValue("download_data", downloadData);
    }
  }, [subscription, categories]);

  const handleSubmitFrom = data => {
    onSubmit(data);
    resetForm && resetForm();
  };

  return (
    <form onSubmit={handleSubmit(handleSubmitFrom)} className="row">
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="subscription_type">Subscription type</label>
        <Controller
          name="subscription_type"
          control={control}
          id="subscription_type"
          render={({ field }) => (
            <Select
              ref={subscriptionTypeRef}
              placeholder="Subscription type"
              options={[
                { label: "Light", value: "Light" },
                { label: "Advanced", value: "Advanced" },
                { label: "Expert", value: "Expert" }
              ]}
              onChange={val => {
                field.onChange(val);
              }}
            />
          )}
        />
        {errors.subscription_type && (
          <div className="text-danger">{errors.subscription_type.message}</div>
        )}
      </Col>
      <Col sm={6} className="d-flex flex-column mb-3">
        {/* expiration_date */}
        <label htmlFor="expiration_date">Expiration Date</label>
        <Controller
          control={control}
          name="expiration_date"
          id="expiration_date"
          render={({ field }) => (
            <DatePicker
              className="form-control"
              ref={expirationDateRef}
              placeholderText="Select expiration date"
              dateFormat="yyyy-MM-dd"
              onChange={date => {
                field.onChange(date);
              }}
              selected={field.value}
            />
          )}
        />
        {errors.expiration_date && (
          <div className="text-danger">{errors.expiration_date.message}</div>
        )}
      </Col>
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="show_affinity_numbers">Show affinity numbers</label>
        <input
          type="checkbox"
          className="form-control"
          {...register("show_affinity_numbers")}
          defaultChecked
        />
        {errors.show_affinity_numbers && (
          <div className="text-danger">
            {errors.show_affinity_numbers.message}
          </div>
        )}
      </Col>
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="download_data">Download data</label>
        <input
          type="checkbox"
          className="form-control"
          {...register("download_data")}
        />
        {errors.download_data && (
          <div className="text-danger">{errors.download_data.message}</div>
        )}
      </Col>
      <Col sm={12} className="d-flex flex-column mb-3">
        <label htmlFor="country_datasets">Country Dataset</label>
        <Controller
          control={control}
          id="country_datasets"
          name="country_datasets"
          render={({ field }) => (
            <Select
              ref={dataSetsRef}
              placeholder="Country Dataset"
              options={allCountryDatasets.map(item => ({
                value: item.id,
                label: item.name,
                item
              }))}
              isMulti
              onChange={val => {
                handleCountryDataSetChange(val);
                field.onChange(val);
              }}
            />
          )}
        />
        {errors.country_datasets && (
          <div className="text-danger">{errors.country_datasets.message}</div>
        )}
      </Col>
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="additional_categories">Additional Categories</label>
        <Controller
          control={control}
          name="additional_categories"
          id="additional_categories"
          render={({ field }) => (
            <Select
              ref={additionalCategoriesRef}
              placeholder="Additional Categories"
              options={allowedAddCategories.map(item => ({
                value: item.id,
                label: item.name,
                item
              }))}
              isMulti
              onChange={val => {
                field.onChange(val);
              }}
            />
          )}
        />
        {errors.additional_categories && (
          <div className="text-danger">
            {errors.additional_categories.message}
          </div>
        )}
      </Col>
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="excluded_categories">Excluded Categories</label>
        <Controller
          control={control}
          name="excluded_categories"
          id="excluded_categories"
          render={({ field }) => (
            <Select
              ref={excludedCategoriesRef}
              placeholder="Excluded Categories"
              options={allowedExcCategories.map(item => ({
                value: item.id,
                label: item.name,
                item
              }))}
              isMulti
              onChange={val => {
                field.onChange(val);
              }}
            />
          )}
        />
        {errors.excluded_categories && (
          <div className="text-danger">
            {errors.excluded_categories.message}
          </div>
        )}
      </Col>
      <Col sm={12}>
        <input type="submit" className="btn btn-success" />
      </Col>
    </form>
  );
};

CompanySubscription.propTypes = {
  subscription: PropTypes.shape({
    subscriptionType: PropTypes.string,
    countryDatasets: PropTypes.arrayOf(PropTypes.shape({})),
    excludedCategories: PropTypes.arrayOf(PropTypes.shape({})),
    expirationDate: PropTypes.string,
    additionalCategories: PropTypes.arrayOf(PropTypes.shape({})),
    showAffinityNumbers: PropTypes.bool,
    downloadData: PropTypes.bool
  }),
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  allCountryDatasets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  resetForm: PropTypes.func
};

CompanySubscription.defaultProps = {
  subscription: null,
  resetForm: PropTypes.func
};

export default React.memo(CompanySubscription);
